import { Observable, useObservable } from '../../util/Observable';
import { run } from '../../util/run';
import { BrowserService } from '../BrowserService';
import { Public } from '../Public.type';
import { useServices } from '../Services';
import { SsrData } from '../SsrData';

export class ScreenSizeService {
  constructor(private ssrData: SsrData, private browser: Public<BrowserService>) {
    const { window } = browser;

    if (window) {
      window.addEventListener('resize', this.update, { passive: true });
      this.dispose = () => window.removeEventListener('resize', this.update);
      void Promise.resolve().then(this.update);
    } else {
      this.update();
    }
  }

  private update = () => {
    const { info, window } = this.browser;

    const nextSize = run(() => {
      if (window) {
        return window.innerWidth >= 768 ? 'desktop' : 'mobile';
      } else {
        const hasDeviceType = Boolean(info.device?.type);
        const hasBrowserName = Boolean(info.agent?.name);

        // In the case of bots like google, the browser name will be blank.
        // In the case of recognized desktop devices, the device type will be blank
        return hasDeviceType || !hasBrowserName ? 'mobile' : 'desktop';
      }
    });

    if (nextSize !== this.observable.getValue()) this.setValue(nextSize);
  };

  public dispose?: () => void;

  private setValue = (size: ScreenSize) => {
    this.slot.value = size;
    this.observable.setValue(size);
  };

  private slot: { value: ScreenSize } = this.ssrData.slot('SCREEN_SIZE', () => ({
    value: 'mobile',
  }));
  public observable = new Observable(this.slot.value);
}

export const useMobile = () => useObservable(useServices().screenSize.observable) === 'mobile';

export type ScreenSize = 'mobile' | 'desktop';
